export default {
  name: "Top8Vantage",
  data() {
    return {
      showImageModal: false,
      selectedImage: {
        src: "",
        caption: "",
      },
    };
  },
  mounted() {
    // Restore scroll position after language change (page reload)
    const savedScrollY = Number(localStorage.getItem("scrollY"));
    if (!Number.isNaN(savedScrollY) && savedScrollY > 0) {
      // Use next tick to ensure DOM is rendered before restoring position
      this.$nextTick(() => {
        window.scrollTo({
          top: savedScrollY,
          behavior: "auto",
        });
        // prevent affecting other pages later
        localStorage.removeItem("scrollY");
      });
      return;
    }

    // Default behavior: first time enter this page => go to top
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  methods: {
    goToContact() {
      this.$router.push({ name: "Contact" });
    },
    openImageModal(image) {
      this.selectedImage = image || { src: "", caption: "" };
      this.showImageModal = true;
    },
    closeImageModal() {
      this.showImageModal = false;
      this.selectedImage = { src: "", caption: "" };
    },
  },
};
